<template>
  <div class="max-w-5xl shadow entry-overview flex overflow-hidden bg-white sm:rounded-lg">
    <!-- Content area -->
    <div class="entry-detail w-full">
      <div class="flex max-w-4xl flex-col">
        <main class="flex-1">
          <div class="relative mx-auto max-w-4xl md:px-8">
            <div class="pt-10 pb-16">
              <div class="px-4 sm:px-6 md:px-0">
                <p class="text-sm">
                  Project Plan <span class="text-gray-400">→ {{ project.name }}</span>
                </p>
                <h1 class="text-3xl font-bold tracking-tight text-gray-900">
                  {{ proposal.title }}
                </h1>
              </div>
              <div class="px-4 sm:px-6 md:px-0">
                <div class="py-6">
                  <!-- Tabs -->
                  <div class="lg:hidden">
                    <label
                      for="selected-tab"
                      class="sr-only">
                      Select a tab
                    </label>
                    <select
                      id="selected-tab"
                      name="selected-tab"
                      class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-purple-500 focus:outline-none focus:ring-purple-500 sm:text-sm">
                      <option
                        v-for="tab in tabs"
                        :key="tab.name"
                        :selected="(tab.name === 'Tour Leader dialogue')">
                        {{ tab.name }}
                      </option>
                    </select>
                  </div>
                  <div class="hidden lg:block">
                    <div class="border-b border-gray-200">
                      <nav class="-mb-px flex space-x-8">
                        <Link
                          v-for="tab in tabs"
                          :key="tab.name"
                          :href="tab.route ? route(tab.route) : tab.href"
                          :class="[(tab.name === 'Tour Leader dialogue') ? 'border-purple-500 text-purple-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm']">
                          {{ tab.name }}
                        </Link>
                      </nav>
                    </div>
                  </div>

                  <!-- ---- ---- Content START ---- ---- -->
                  <Content as="div">
                    <!-- First box -->
                    <div class="relative mt-6 max-w-5xl mx-auto">
                      Client dialogue will be available here
                    </div>

                  </Content>
                  <!-- ---- ---- Content END ---- ---- -->

                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup>
/* external */
import { ref } from 'vue';
import { Link } from '@inertiajs/vue3';
import FormattedDateRange from '@/ComponentsDeprecated/Time/FormattedDateRange';

/* local */
import { tabs, project, proposal } from './ProjectPlanDummy';

const accessClient = ref(false);
const accessTourManager = ref(true);

</script>
